import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { genericProperty } from 'modules/mac/duck/api/genericProperty';
import { FETCH_GENERIC_PROPERTY } from './types';

export const fetchGenericProperty =
  (fullKey: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    const genericPropertyData = genericProperty(fullKey, state);
    dispatch(thunkProgress(FETCH_GENERIC_PROPERTY, genericPropertyData, { fullKey }));
  };
